import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { db } from "../../../firebase/firebase";
import { collection, query, where, getDocs, limit } from "firebase/firestore";
import { QueryKeys } from "config/query-keys";
import { EnumeratorInterface } from "./dto";

const getEnumeratorProfileInfo = async (uid: string| undefined): Promise<EnumeratorInterface> => {
  if (!uid) {
    throw new Error("No user ID provided.");
  }

  const userQuery = query(
    collection(db, "user_infos"),
    where("uid", "==", uid),
    limit(1)
  );

  const querySnapshot = await getDocs(userQuery);

  if (querySnapshot.empty) {
    throw new Error("No such user found: " + uid);
  }

  return querySnapshot.docs[0].data() as EnumeratorInterface;
};

export const useGetEnumeratorProfileInfo = (uid: string | undefined) => {
  return useQuery<EnumeratorInterface | null, AxiosError>({
    queryKey: [QueryKeys.ENUMERATOR, uid],
    queryFn: () => getEnumeratorProfileInfo(uid!),
    enabled: !!uid,
    retry: 1,
  });
};
